import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.esm.js';
import React__default from 'react';
import { NvTabsContextProvider } from '../NvTabsContext/NvTabsContext.esm.js';

var NvTabsContainer = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React__default.createElement(NvTabsContextProvider, __assign({}, props), children);
};

export { NvTabsContainer };
//# sourceMappingURL=NvTabsContainer.esm.js.map
